(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["social_share"] && !Shopify.designMode) return;
  try {
    (() => {
    const NO = 'noopener,noreferrer';
    const POPUP = `width=626,height=436,left=120,top=120,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,${NO}`;

    const openShare = (url, target, features) => {
      const w = window.open(url, target, features);
      if (w) w.opener = null;
    };

    const init = () => {
      document.querySelectorAll('[data-social-share-root]').forEach((root) => {
        if (root.dataset.socialShareInit === '1') return;
        root.dataset.socialShareInit = '1';

        const id = root.id || 'share';

        root.querySelectorAll('a[data-social-share-item]').forEach((a) => {
          a.addEventListener('click', (e) => {
            if (e.defaultPrevented || e.button !== 0) return;
            const { shareUrl: url } = a.dataset;
            if (!url || url.startsWith('javascript:')) return;
            e.preventDefault();
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
              openShare(url, `SocialShare_${id}_mod`, NO);
              return;
            }
            openShare(url, `SocialShare_${id}`, POPUP);
          });
        });

        const toggle = root.querySelector('[data-social-share-toggle]');
        const items = root.querySelectorAll('[data-social-share-item]');
        if (!toggle) return;
        if (items.length <= 3) {
          toggle.hidden = true;
          return;
        }
        toggle.addEventListener('click', () => {
          const on = root.classList.toggle('social-share--expanded');
          toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
          const icon = toggle.querySelector('.social-share__toggle-icon');
          const pulse =
            root.classList.contains('social-share--toggle-hamburger') ||
            (root.classList.contains('social-share--toggle-custom') && root.dataset.toggleCustomAnim === 'scale_click');
          if (pulse && icon) {
            icon.classList.remove('social-share__toggle-icon--pulse');
            icon.offsetWidth;
            icon.classList.add('social-share__toggle-icon--pulse');
          }
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
